import {Component, Input, OnInit} from '@angular/core';
import {AlertState} from "../../types/alert-state.type";

@Component({
  selector: 'app-label-state',
  templateUrl: './label-state.component.html',
  styleUrls: ['./label-state.component.scss'],
})
export class LabelStateComponent  implements OnInit {

  @Input() label: string;
  @Input() type: AlertState = 'success';

  constructor() { }

  ngOnInit() {}

}
